var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import analysisPlanActions from "../actions/AnalysisPlanActions.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
const initialState = {
  analysisGroupInEditor: null,
  analysisGroups: [],
  availableTemplates: [],
  canManagementGroupShowComponent: false,
  isEditMode: false,
  isVisible: false,
  enableCustomSideStreamTriggerBuilder: false,
  withNoTrigger: false
};
class AnalysisPlanReducer {
  setAnalysisGroupInEditor(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      analysisGroupInEditor: action.payload
    });
  }
  getAnalysisPlan(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      analysisGroups: action.payload
    });
  }
  getAvailableTemplates(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      availableTemplates: action.payload
    });
  }
  removeAnalysisGroup(state, action) {
    let analysisGroups = Object.assign([], state.analysisGroups);
    analysisGroups[action.payload].isRemoved = true;
    return __spreadProps(__spreadValues({}, state), {
      analysisGroups
    });
  }
  undoRemoveAnalysisGroup(state, action) {
    let analysisGroups = Object.assign([], state.analysisGroups);
    analysisGroups[action.payload].isRemoved = false;
    return __spreadProps(__spreadValues({}, state), {
      analysisGroups
    });
  }
  saveAnalysisPlan(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      analysisGroups: action.payload,
      isEditMode: false
    });
  }
  getShowAnalysisPlanComponent(state, action) {
    const isShowing = action.payload;
    return __spreadProps(__spreadValues({}, state), {
      canManagementGroupShowComponent: isShowing
    });
  }
  setEditMode(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      isEditMode: action.payload
    });
  }
  setVisible(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      isVisible: action.payload
    });
  }
  clearValidationErrors(state, action) {
    let analysisGroupInEditor = Object.assign({}, state.analysisGroupInEditor);
    analysisGroupInEditor.validationError = null;
    return __spreadProps(__spreadValues({}, state), {
      analysisGroupInEditor
    });
  }
  getEnableCustomSideStreamTriggerBuilder(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      enableCustomSideStreamTriggerBuilder: action.payload.enableCustomSideStreamTriggerBuilder,
      withNoTrigger: action.payload.withNoTrigger
    });
  }
  validateAndSaveAnalysisGroup(state, action) {
    let analysisGroups = Object.assign([], state.analysisGroups);
    const analysisGroupInEditor = action.payload;
    if (!analysisGroupInEditor.validationError) {
      if (analysisGroupInEditor.index === null || analysisGroupInEditor.index === void 0) {
        analysisGroups.push(analysisGroupInEditor.analysisGroup);
      } else {
        analysisGroups[analysisGroupInEditor.index] = analysisGroupInEditor.analysisGroup;
      }
    }
    return __spreadProps(__spreadValues({}, state), {
      analysisGroups,
      analysisGroupInEditor
    });
  }
}
const reducer = createReducer(analysisPlanActions, new AnalysisPlanReducer(), initialState);
export {
  AnalysisPlanReducer,
  reducer as default
};
//# sourceMappingURL=AnalysisPlanReducer.js.map
